export default "__VITE_ASSET__d2400ca2__"